// extracted by mini-css-extract-plugin
module.exports = {"outer":"ProductColors_outer__8iSRi","outline":"ProductColors_outline__pVIda","link":"ProductColors_link__kywcM"};